import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private pendingScrollTarget: string | null = null;
  private isBrowser: boolean;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.pendingScrollTarget) {
          this.scrollToSection(this.pendingScrollTarget);
          this.pendingScrollTarget = null;
        }
      });
  }

  navigateToLightingProjects(): void {
    const currentRoute = this.router.url;

    if (currentRoute === '/projects') {
      this.scrollToLightingSection();
    } else {
      this.pendingScrollTarget = this.getLightingSectionId();
      this.router.navigate(['/projects']);
    }
  }

  private scrollToLightingSection(): void {
    const sectionId = this.getLightingSectionId();
    this.scrollToSection(sectionId);
  }

  private getLightingSectionId(): string {
    if (!this.isBrowser) return 'lighting-projects';

    const isMobile = window.innerWidth < 768;
    return isMobile ? 'mobile-lighting-projects' : 'lighting-projects';
  }

  private scrollToSection(sectionId: string): void {
    if (!this.isBrowser) return;

    setTimeout(() => {
      const targetElement = document.getElementById(sectionId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 100);
  }
}
